<template>
  <div class="page-container">
    <v-container fluid>
      <!-- Main Content Card -->
      <v-card class="main-form-card" elevation="0">
        <v-card-text class="pa-8">
          <!-- Page Title -->
          <div class="page-header d-flex justify-space-between align-center">
            <div class="d-flex mb-2">
                <v-img
                  :src="images.MTestIcon1"
                  alt="Question Icon"
                  max-width="25"
                  min-width="25"
                  height="25"
                  style="margin-right: 15px;"
                ></v-img>
              <div>
                <h1 class="page-title">Generate Question Set</h1>
              </div>
            </div>
            <div>
              <v-btn 
                variant="outlined"
                size="large"
                to="/ValidationGenerate"
                class="back-button mr-4 customback"
                style="width: 120px;"
              >
                Back
              </v-btn>
              
              <v-btn 
                id="button-process-validationgenerateupload" 
                variant="flat"
                color="primary"
                size="default"
                @click="Save()"
                class="create-btn"
                style="width: 150px;"
                :disabled="Validation.temperature === '' || Validation.topP === '' "
              >
                <v-img
                  :src="images.processImg"
                  alt="Process Icon"
                  max-width="20"
                  min-width="20"
                  height="20"
                  class="mr-2"
                ></v-img>
                Process
              </v-btn>
            </div>
          </div>

          <!-- Form -->
          <v-form ref="form" v-model="valid" lazy-validation>
            <div class="form-layout">
              <!-- Left Column -->
              <div class="form-left-panel">
                <!-- Question Set Name -->
                <div class="form-section">
                  <label class="field-label">
                    Question Set Name
                    <span style="color: red;">*</span>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <v-icon v-bind="props" color="grey-darken-1" size="small" class="ml-1">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>The name of the set of questions.</span>
                    </v-tooltip>
                  </label>
                  <v-text-field 
                    id="questionsetname-field-validationgenerateupload" 
                    placeholder="Enter Question Set Name" 
                    v-model="Validation.validationName"
                    :rules="[rules.required]" 
                    required 
                    variant="outlined"
                    density="comfortable"
                    class="modern-input mt-2"
                  >
                    <template v-slot:append-inner>
                      <v-tooltip location="top">
                        <span>{{ $t('_InfoValidationName') }}</span>
                      </v-tooltip> 
                    </template>
                  </v-text-field>
                </div>
                
                <div>
                  <!-- Form -->
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <!-- Left Column -->
                    <div>
                      <!-- Custom Accordion Panels -->
                      <div class="custom-accordion">

                        <!-- Knowledge Documents Panel -->
                        <div class="accordion-item" :class="{ 'is-open': openPanels.knowledge }">
                          <div class="accordion-header" @click="togglePanel('knowledge')">
                            <div class="accordion-header-content">
                              <div class="accordion-icon-wrapper">
                                <v-img :src="images.knowledgeImg" alt="Knowledge Icon" width="20" height="20"
                                  contain></v-img>
                              </div>
                              <span class="accordion-title">Knowledge Documents</span>
                            </div>
                            <v-icon class="accordion-chevron" size="30" :class="{ 'rotated': openPanels.knowledge }">
                              mdi-menu-down
                            </v-icon>
                          </div>
                          <div class="accordion-content" v-show="openPanels.knowledge">
                            <div class="accordion-body">
                              <div class="form-grid">
                                <label class="field-label">
                                  Document Name
                                  <span style="color: red;">*</span>
                                  <v-tooltip location="top" max-width="300px">
                                    <template v-slot:activator="{ props }">
                                      <v-icon v-bind="props" color="grey-darken-1" size="small" class="ml-1">
                                        mdi-information-outline
                                      </v-icon>
                                    </template>
                                    <span>Enter the file name or descriptive title for this specific source document that the model will reference.</span>
                                  </v-tooltip>
                                </label>
                                <v-autocomplete id="documentname-autocomplete-validationgenerateupload"
                                  placeholder="Select Document Name" :items="DDVector" item-title="name" item-value="name" chips
                                  closable-chips multiple clearable variant="outlined" density="comfortable"
                                  v-model="Validation.vectordbName" :rules="[rules.required]" required
                                  class="modern-autocomplete" @update:model-value="validate">
                                  <template v-slot:item="{ props, item, index }">
                                    <v-list-item v-bind="props" :id="'documentname-option-' + index"
                                      :value="item.raw.name">
                                      <template v-slot:title>
                                        <span>{{ item.raw.name }}</span>
                                      </template>
                                    </v-list-item>
                                  </template>
                                </v-autocomplete>

                                <label class="field-label">
                                  Questions Per Chunk
                                  <span style="color: red;">*</span>
                                  <v-tooltip location="top" max-width="300px">
                                    <template v-slot:activator="{ props }">
                                      <v-icon v-bind="props" color="grey-darken-1" size="small" class="ml-1">
                                        mdi-information-outline
                                      </v-icon>
                                    </template>
                                    <span>Enter the maximum number of questions to be generated for every chunk of text processed from the knowledge source.</span>
                                  </v-tooltip>
                                </label>
                                <v-text-field id="questionsperchunk-field-validationgenerateupload"
                                  placeholder="Enter Questions Per Chunk" @keypress="isNumberInt($event)" clearable
                                  density="comfortable" variant="outlined" v-model="Validation.amountQuestions"
                                  :rules="[rules.required]" class="modern-input">
                                  <template v-slot:append-inner>
                                  </template>
                                </v-text-field>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Parameters Panel -->
                        <div class="accordion-item" :class="{ 'is-open': openPanels.parameters }">
                          <div class="accordion-header" @click="togglePanel('parameters')">
                            <div class="accordion-header-content">
                              <div class="accordion-icon-wrapper">
                                <v-img :src="images.parametersImg" alt="Parameters Icon" width="20" height="20"
                                  contain></v-img>
                              </div>
                              <span class="accordion-title">Parameters</span>
                            </div>
                            <v-icon class="accordion-chevron" size="30" :class="{ 'rotated': openPanels.parameters }">
                              mdi-menu-down
                            </v-icon>
                          </div>
                          <div class="accordion-content" v-show="openPanels.parameters">
                            <div class="accordion-body">
                              <div class="form-grid-2">
                                <!-- Temperature -->
                                <div class="form-field-group">
                                  <label class="field-label">
                                    Temperature
                                    <span style="color: red;">*</span>
                                    <v-tooltip location="top" max-width="300px">
                                      <template v-slot:activator="{ props }">
                                        <v-icon v-bind="props" color="grey-darken-1" size="small" class="ml-1">
                                          mdi-information-outline
                                        </v-icon>
                                      </template>
                                      <span>{{ $t('_InfoTemperature') }}</span>
                                    </v-tooltip>
                                  </label>
                                  <v-text-field 
                                    v-model="Validation.temperature"
                                    placeholder="0.7"
                                    @keypress="isNumber($event)" 
                                    variant="outlined" 
                                    density="compact"
                                    :rules="[validateInput0_1(Validation.temperature)]" 
                                    required 
                                    class="modern-input"
                                    hide-details="auto">
                                  </v-text-field>
                                </div>
                          
                                <!-- Top P -->
                                <div class="form-field-group">
                                  <label class="field-label">
                                    Top P
                                    <v-tooltip location="top" max-width="300px">
                                      <template v-slot:activator="{ props }">
                                        <v-icon v-bind="props" color="grey-darken-1" size="small" class="ml-1">
                                          mdi-information-outline
                                        </v-icon>
                                      </template>
                                      <span>{{ $t('_InfoTopP') }}</span>
                                    </v-tooltip>
                                  </label>
                                  <v-text-field 
                                    v-model="Validation.topP" 
                                    placeholder="0.7"
                                    @keypress="isNumber($event)"
                                    variant="outlined" 
                                    density="compact" 
                                    :rules="[validateInput0_1(Validation.topP)]"
                                    required 
                                    class="modern-input"
                                    hide-details="auto">
                                  </v-text-field>
                                </div>
                          
                                <!-- Frequency Penalty -->
                                <div class="form-field-group">
                                  <label class="field-label">
                                    Frequency Penalty
                                    <v-tooltip location="top" max-width="300px">
                                      <template v-slot:activator="{ props }">
                                        <v-icon v-bind="props" color="grey-darken-1" size="small" class="ml-1">
                                          mdi-information-outline
                                        </v-icon>
                                      </template>
                                      <span>{{ $t('_InfoFrequencyPenalty') }}</span>
                                    </v-tooltip>
                                  </label>
                                  <v-text-field 
                                    v-model="Validation.frequencyPenalty"
                                    placeholder="Enter Frequency Penalty Value"
                                    @keypress="isNumber($event)" 
                                    variant="outlined" 
                                    density="compact"
                                    :rules="[validateInput0_2(Validation.frequencyPenalty)]" 
                                    class="modern-input"
                                    hide-details="auto">
                                  </v-text-field>
                                </div>
                          
                                <!-- Presence Penalty -->
                                <div class="form-field-group">
                                  <label class="field-label">
                                    Presence Penalty
                                    <v-tooltip location="top" max-width="300px">
                                      <template v-slot:activator="{ props }">
                                        <v-icon v-bind="props" color="grey-darken-1" size="small" class="ml-1">
                                          mdi-information-outline
                                        </v-icon>
                                      </template>
                                      <span>{{ $t('_InfoPresencePenalty') }}</span>
                                    </v-tooltip>
                                  </label>
                                  <v-text-field 
                                    v-model="Validation.presencePenalty"
                                    placeholder="Enter Presence Penalty Value"
                                    @keypress="isNumber($event)" 
                                    variant="outlined" 
                                    density="compact"
                                    :rules="[validateInput0_2(Validation.presencePenalty)]" 
                                    class="modern-input"
                                    hide-details="auto">
                                  </v-text-field>
                                </div>
                          
                                <!-- Max Tokens Response -->
                                <div class="form-field-group">
                                  <label class="field-label">
                                    Max Tokens Response
                                    <v-tooltip location="top" max-width="300px">
                                      <template v-slot:activator="{ props }">
                                        <v-icon v-bind="props" color="grey-darken-1" size="small" class="ml-1">
                                          mdi-information-outline
                                        </v-icon>
                                      </template>
                                      <span>{{ $t('_InfoMaxToken') }}</span>
                                    </v-tooltip>
                                  </label>
                                  <v-select
                                    v-model="Validation.maxTokens"
                                    :items="[2000, 3000]"
                                    placeholder="Max Tokens Response"
                                    clearable
                                    variant="outlined" 
                                    density="compact"
                                    class="modern-autocomplete"
                                    hide-details="auto">
                                  </v-select>
                                </div>
                          
                                <!-- Stop Sequence -->
                                <div class="form-field-group">
                                  <label class="field-label">
                                    Stop Sequence
                                    <v-tooltip location="top" max-width="300px">
                                      <template v-slot:activator="{ props }">
                                        <v-icon v-bind="props" color="grey-darken-1" size="small" class="ml-1">
                                          mdi-information-outline
                                        </v-icon>
                                      </template>
                                      <span>Set The end of sequence</span>
                                    </v-tooltip>
                                  </label>
                                  <v-text-field 
                                    v-model="Validation.stop"
                                    placeholder="Enter Stop Sequence Value"
                                    variant="outlined"
                                    density="compact" 
                                    class="modern-input"
                                    hide-details="auto">
                                  </v-text-field>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Tone Panel -->
                        <div class="accordion-item" :class="{ 'is-open': openPanels.tone }">
                          <div class="accordion-header" @click="togglePanel('tone')">
                            <div class="accordion-header-content">
                              <div class="accordion-icon-wrapper">
                                <v-img :src="images.toneImg" alt="Tone Icon" width="20" height="20" contain></v-img>
                              </div>
                              <span class="accordion-title">Tone</span>
                            </div>
                            <v-icon class="accordion-chevron" size="30" :class="{ 'rotated': openPanels.tone }">
                              mdi-menu-down
                            </v-icon>
                          </div>
                          <div class="accordion-content" v-show="openPanels.tone">
                            <div class="accordion-body py-3">
                              <div class="form-grid">
                                <label class="field-label">
                                  Question Per Tone
                                  <span style="color: red;">*</span>
                                  <v-tooltip location="top" max-width="300px">
                                    <template v-slot:activator="{ props }">
                                      <v-icon v-bind="props" color="grey-darken-1" size="small" class="ml-1">
                                        mdi-information-outline
                                      </v-icon>
                                    </template>
                                    <span>Set the number to create questions for each tone.</span>
                                  </v-tooltip>
                                </label>
                                <v-text-field id="questionspertone-field-validationgenerateupload"
                                  placeholder="Questions per Tone" @keypress="isNumberInt($event)" clearable
                                  density="comfortable" variant="outlined" v-model="Validation.amountQuestionsWithTone"
                                  :disabled="chkTone()" :rules="[rules.required]" class="modern-input">
                                </v-text-field>
                              </div>

                              <!-- Tone Options Grid -->
                              <div class="tone-grid">
                                <v-card class="tone-option-card" :class="{ 'selected': Validation.firm }"
                                  @click="toggleTone('firm')">
                                  <v-card-text class="tone-card-content">
                                    <div class="d-flex align-start">
                                      <v-checkbox id="firm-checkbox-validationgenerateupload" v-model="Validation.firm"
                                        color="primary" density="comfortable"
                                        @change="InsertTextToPrompt(Validation.firm, 'Firm')" hide-details
                                        class="tone-checkbox-minimal" @click.stop />
                                      <div class="tone-content ml-3">
                                        <h4 class="tone-title">Firm</h4>
                                        <p class="tone-description">Generate questions with decisive and assertive
                                          language that demands clear, definitive answers</p>
                                      </div>
                                    </div>
                                  </v-card-text>
                                </v-card>

                                <!-- Confident -->
                                <v-card class="tone-option-card" :class="{ 'selected': Validation.confident }"
                                  @click="toggleTone('confident')">
                                  <v-card-text class="tone-card-content">
                                    <div class="d-flex align-start">
                                      <v-checkbox id="confident-checkbox-validationgenerateupload"
                                        v-model="Validation.confident" color="primary" density="comfortable"
                                        @change="InsertTextToPrompt(Validation.confident, 'Confident')" hide-details
                                        class="tone-checkbox-minimal" @click.stop />
                                      <div class="tone-content ml-3">
                                        <h4 class="tone-title">Confident</h4>
                                        <p class="tone-description">Create questions with strong conviction and
                                          certainty that inspire authoritative responses</p>
                                      </div>
                                    </div>
                                  </v-card-text>
                                </v-card>

                                <!-- Poetic -->
                                <v-card class="tone-option-card" :class="{ 'selected': Validation.poetic }"
                                  @click="toggleTone('poetic')">
                                  <v-card-text class="tone-card-content">
                                    <div class="d-flex align-start">
                                      <v-checkbox id="poetic-checkbox-validationgenerateupload"
                                        v-model="Validation.poetic" color="primary" density="comfortable"
                                        @change="InsertTextToPrompt(Validation.poetic, 'Poetic')" hide-details
                                        class="tone-checkbox-minimal" @click.stop />
                                      <div class="tone-content ml-3">
                                        <h4 class="tone-title">Poetic</h4>
                                        <p class="tone-description">Craft questions with artistic and expressive
                                          language that evokes creativity and imagination</p>
                                      </div>
                                    </div>
                                  </v-card-text>
                                </v-card>

                                <!-- Narrative -->
                                <v-card class="tone-option-card" :class="{ 'selected': Validation.narrative }"
                                  @click="toggleTone('narrative')">
                                  <v-card-text class="tone-card-content">
                                    <div class="d-flex align-start">
                                      <v-checkbox id="narrative-checkbox-validationgenerateupload"
                                        v-model="Validation.narrative" color="primary" density="comfortable"
                                        @change="InsertTextToPrompt(Validation.narrative, 'Narrative')" hide-details
                                        class="tone-checkbox-minimal" @click.stop />
                                      <div class="tone-content ml-3">
                                        <h4 class="tone-title">Narrative</h4>
                                        <p class="tone-description">Design questions that encourage storytelling and
                                          detailed explanations with context</p>
                                      </div>
                                    </div>
                                  </v-card-text>
                                </v-card>

                                <!-- Professional -->
                                <v-card class="tone-option-card" :class="{ 'selected': Validation.professional }"
                                  @click="toggleTone('professional')">
                                  <v-card-text class="tone-card-content">
                                    <div class="d-flex align-start">
                                      <v-checkbox id="professional-checkbox-validationgenerateupload"
                                        v-model="Validation.professional" color="primary" density="comfortable"
                                        @change="InsertTextToPrompt(Validation.professional, 'Professional')"
                                        hide-details class="tone-checkbox-minimal" @click.stop />
                                      <div class="tone-content ml-3">
                                        <h4 class="tone-title">Professional</h4>
                                        <p class="tone-description">Generate questions using business-appropriate
                                          language suitable for workplace communications</p>
                                      </div>
                                    </div>
                                  </v-card-text>
                                </v-card>

                                <!-- Descriptive -->
                                <v-card class="tone-option-card" :class="{ 'selected': Validation.descriptive }"
                                  @click="toggleTone('descriptive')">
                                  <v-card-text class="tone-card-content">
                                    <div class="d-flex align-start">
                                      <v-checkbox id="descriptive-checkbox-validationgenerateupload"
                                        v-model="Validation.descriptive" color="primary" density="comfortable"
                                        @change="InsertTextToPrompt(Validation.descriptive, 'Descriptive')" hide-details
                                        class="tone-checkbox-minimal" @click.stop />
                                      <div class="tone-content ml-3">
                                        <h4 class="tone-title">Descriptive</h4>
                                        <p class="tone-description">Create questions that prompt detailed, vivid
                                          explanations and comprehensive responses</p>
                                      </div>
                                    </div>
                                  </v-card-text>
                                </v-card>

                                <!-- Humorous -->
                                <v-card class="tone-option-card" :class="{ 'selected': Validation.humorous }"
                                  @click="toggleTone('humorous')">
                                  <v-card-text class="tone-card-content">
                                    <div class="d-flex align-start">
                                      <v-checkbox id="humorous-checkbox-validationgenerateupload"
                                        v-model="Validation.humorous" color="primary" density="comfortable"
                                        @change="InsertTextToPrompt(Validation.humorous, 'Humorous')" hide-details
                                        class="tone-checkbox-minimal" @click.stop />
                                      <div class="tone-content ml-3">
                                        <h4 class="tone-title">Humorous</h4>
                                        <p class="tone-description">Formulate questions with light-hearted and
                                          entertaining elements that engage users playfully</p>
                                      </div>
                                    </div>
                                  </v-card-text>
                                </v-card>

                                <!-- Academic -->
                                <v-card class="tone-option-card" :class="{ 'selected': Validation.academic }"
                                  @click="toggleTone('academic')">
                                  <v-card-text class="tone-card-content">
                                    <div class="d-flex align-start">
                                      <v-checkbox id="academic-checkbox-validationgenerateupload"
                                        v-model="Validation.academic" color="primary" density="comfortable"
                                        @change="InsertTextToPrompt(Validation.academic, 'Academic')" hide-details
                                        class="tone-checkbox-minimal" @click.stop />
                                      <div class="tone-content ml-3">
                                        <h4 class="tone-title">Academic</h4>
                                        <p class="tone-description">Develop questions using scholarly language
                                          appropriate for educational and research contexts</p>
                                      </div>
                                    </div>
                                  </v-card-text>
                                </v-card>

                                <!-- Persuasive -->
                                <v-card class="tone-option-card" :class="{ 'selected': Validation.persausive }"
                                  @click="toggleTone('persausive')">
                                  <v-card-text class="tone-card-content">
                                    <div class="d-flex align-start">
                                      <v-checkbox id="persausive-checkbox-validationgenerateupload"
                                        v-model="Validation.persausive" color="primary" density="comfortable"
                                        @change="InsertTextToPrompt(Validation.persausive, 'Persausive')" hide-details
                                        class="tone-checkbox-minimal" @click.stop />
                                      <div class="tone-content ml-3">
                                        <h4 class="tone-title">Persuasive</h4>
                                        <p class="tone-description">Generate questions that encourage influential and
                                          convincing responses with strong arguments</p>
                                      </div>
                                    </div>
                                  </v-card-text>
                                </v-card>

                                <!-- Formal -->
                                <v-card class="tone-option-card" :class="{ 'selected': Validation.format }"
                                  @click="toggleTone('format')">
                                  <v-card-text class="tone-card-content">
                                    <div class="d-flex align-start">
                                      <v-checkbox id="format-checkbox-validationgenerateupload"
                                        v-model="Validation.format" color="primary" density="comfortable"
                                        @change="InsertTextToPrompt(Validation.format, 'Format')" hide-details
                                        class="tone-checkbox-minimal" @click.stop />
                                      <div class="tone-content ml-3">
                                        <h4 class="tone-title">Formal</h4>
                                        <p class="tone-description">Create questions using proper, structured language
                                          suitable for official communications</p>
                                      </div>
                                    </div>
                                  </v-card-text>
                                </v-card>

                                <!-- Informal -->
                                <v-card class="tone-option-card" :class="{ 'selected': Validation.informal }"
                                  @click="toggleTone('informal')">
                                  <v-card-text class="tone-card-content">
                                    <div class="d-flex align-start">
                                      <v-checkbox id="informal-checkbox-validationgenerateupload"
                                        v-model="Validation.informal" color="primary" density="comfortable"
                                        @change="InsertTextToPrompt(Validation.informal, 'Informal')" hide-details
                                        class="tone-checkbox-minimal" @click.stop />
                                      <div class="tone-content ml-3">
                                        <h4 class="tone-title">Informal</h4>
                                        <p class="tone-description">Formulate questions using casual, conversational
                                          language for relaxed interactions</p>
                                      </div>
                                    </div>
                                  </v-card-text>
                                </v-card>

                                <!-- Friendly -->
                                <v-card class="tone-option-card" :class="{ 'selected': Validation.friendly }"
                                  @click="toggleTone('friendly')">
                                  <v-card-text class="tone-card-content">
                                    <div class="d-flex align-start">
                                      <v-checkbox id="friendly-checkbox-validationgenerateupload"
                                        v-model="Validation.friendly" color="primary" density="comfortable"
                                        @change="InsertTextToPrompt(Validation.friendly, 'Friendly')" hide-details
                                        class="tone-checkbox-minimal" @click.stop />
                                      <div class="tone-content ml-3">
                                        <h4 class="tone-title">Friendly</h4>
                                        <p class="tone-description">Design questions with warm, approachable language
                                          that creates comfortable dialogue</p>
                                      </div>
                                    </div>
                                  </v-card-text>
                                </v-card>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-form>
                </div>
              </div>

              <!-- Right Column - Prompt Areas -->
              <div class="form-right-panel">
                <div class="prompt-section">
                  <h3 class="section-title">
                    <v-img :src="images.promptImg" max-width="24" class="mr-2"></v-img>
                    Prompt Configuration
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <v-icon v-bind="props" color="grey-darken-1" size="small" class="ml-1">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>Manage the core prompt and parameters used to instruct the generative model when creating a new set of test questions.</span>
                    </v-tooltip>
                  </h3>
                  
                  <v-textarea 
                    placeholder="Add more prompts" 
                    variant="outlined" 
                    counter 
                    auto-grow 
                    rows="8"
                    v-model="Validation.promptMore"
                    class="modern-textarea mb-4"
                    density="comfortable"
                  >
                  </v-textarea>
                  
                  <h3 class="section-title">
                    <v-img :src="images.prompttemplateImg" max-width="24" class="mr-2"></v-img>
                    Prompt Template
                  </h3>
                  <v-textarea 
                    placeholder="Prompt template" 
                    variant="outlined" 
                    counter 
                    auto-grow 
                    rows="12"
                    v-model="Validation.promptTemplate" 
                    :rules="[rules.required]" 
                    required 
                    readonly
                    class="modern-textarea readonly-textarea"
                    density="comfortable"
                  >
                    <template v-slot:append-inner>
                      <div class="d-flex align-center gap-1">                        
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }">
                            <v-btn
                              v-bind="props"
                              icon
                              size="small"
                              variant="text"
                              color="#646464"
                              @click="copyToClipboard(Validation.promptTemplate)"
                              class="copy-btn"
                              :disabled="copyButtonState.copying"
                            >
                              <v-icon size="small">
                                mdi-content-copy
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ copyButtonState.copied ? 'Copied!' : 'Copy' }}</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-textarea>
                </div>
              </div>
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- Loading Dialog -->
    <v-overlay :model-value="dialog" class="align-center justify-center">
      <v-card class="loading-card pa-8" min-width="300">
        <div class="text-center">
          <v-progress-circular
            indeterminate
            color="primary"
            size="48"
            class="mb-4"
          ></v-progress-circular>
          <p class="loading-text mb-0">Loading Please Wait...</p>
        </div>
      </v-card>
    </v-overlay>
        <!-- Warning Dialog -->
    <v-dialog v-model="dialog_warning" max-width="600px" persistent>
      <v-card class="warning-dialog-card">
        <div class="warning-dialog-header">
          <span class="warning-dialog-title">General Test Questions Information is Required !</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="warning-close-icon"
            @click="dialog_warning = false"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span style="font-weight: 400;">
            Please fill in all required information.
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="reprocess-confirm-btn"
            @click="dialog_warning = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
// import DragDropFile from "@/components/DragDropFile.vue";
import MTestIcon1 from "@/assets/images/generatequestion.png";
import processImg from '@/assets/images/process.svg';
import promptImg from '@/assets/images/prompt.png';
import prompttemplateImg from '@/assets/images/prompttemplate.png';
import knowledgeImg from '@/assets/images/knowledge.png';
import parametersImg from '@/assets/images/parameter.png';
import toneImg from '@/assets/images/tone.png';

export default {
  name: 'ValidationGenerateUpload',
  inject: ['flagNav','FontColorTitle','SubNavbarBackGround'],
  // components: { DragDropFile },
  data: () => ({
    props: ['id'],
    id: null,
    valid: true,
    checkbox1: false,
    editAction: false,
    dialog: false,
    dialog_warning: false,
    tempID: 0,
    MenuID1: null,
    MenuID2: null,
    MenuID3: null,
    menuID: null,
    subMenuID: null,
    today: null,
    maxLengthChar: 0,
    loading: true,
    panel: [0],
    DDVector: [],
    copyButtonState: {
      copied: false,
      copying: false
    },
    rules: {
      required: (value) => !!value || 'Required.',
      required: (value) => {
      // ถ้าเป็น array (autocomplete multiple) ให้เช็ค length
      if (Array.isArray(value)) {
        return value.length > 0 || 'Required.'
      }
      // ปกติให้เช็ค truthy
      return !!value || 'Required.'
    },
    },
    images: {
      MTestIcon1: MTestIcon1,
      processImg: processImg,
      promptImg: promptImg,
      prompttemplateImg: prompttemplateImg,
      knowledgeImg: knowledgeImg,
      parametersImg: parametersImg,
      toneImg: toneImg,
    },
    openPanels: {
      knowledge: true,
      parameters: false,
      tone: false
    },
    tempAmountQuestions: 3,
    Validation: {
      validationName: null,
      vectordbName: null,
      tone: [],
      topVDB: null,
      amountQuestions: 3,
      amountQuestionsWithTone: 0,
      promptTemplate: null,
      promptMore: null,
      temperature: 0.7,
      topP: 0.7,
      frequencyPenalty: null,
      presencePenalty: null,
      maxTokens: null,
      stop: null,
      positive: true,
      firm: false,
      confident: false,
      poetic: false,
      narrative: false,
      professional: false,
      descriptive: false,
      humorous: false,
      academic: false,
      persausive: false,
      format: false,
      informal: false,
      friendly: false,
      entity: null,
    },
    DDModelShow: [],
  }),
  watch: {
    '$route.params.id': function (newParam) {
      // อัพเดตค่าพารามิเตอร์ด้วยตัวเอง
      this.id = newParam;
    },    
  },
  methods: {
    togglePanel(panelName) {
    // Use Vue.set or direct assignment with $set for better reactivity
    // this.$set(this.openPanels, panelName, !this.openPanels[panelName]);
    // Or use this approach:
    this.openPanels = { ...this.openPanels, [panelName]: !this.openPanels[panelName] };
  },
    async copyToClipboard(text) {
      // ป้องกันการคลิกซ้ำ
      if (this.copyButtonState.copying) return;
      
      this.copyButtonState.copying = true;
      
      try {
        await navigator.clipboard.writeText(text);
        
        // เปลี่ยนเป็นไอคอนถูก
        this.copyButtonState.copied = true;
        this.copyButtonState.copying = false;
        setTimeout(() => {
          this.copyButtonState.copied = false;
        }, 3000);
        
      } catch (err) {
        // Fallback for browsers that don't support clipboard API
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        
        try {
          document.execCommand('copy');
          
          // เปลี่ยนเป็นไอคอนถูก
          this.copyButtonState.copied = true;
          this.copyButtonState.copying = false;
          setTimeout(() => {
            this.copyButtonState.copied = false;
          }, 3000);
          
        } catch (fallbackErr) {
          this.copyButtonState.copying = false;
        }
        
        document.body.removeChild(textArea);
      }
    },
    toggleTone(toneType) {
      const toneMap = {
        'firm': 'Firm',
        'confident': 'Confident',
        'poetic': 'Poetic',
        'narrative': 'Narrative',
        'professional': 'Professional',
        'descriptive': 'Descriptive',
        'humorous': 'Humorous',
        'academic': 'Academic',
        'persausive': 'Persausive',
        'format': 'Format',
        'informal': 'Informal',
        'friendly': 'Friendly'
      };
      
      this.Validation[toneType] = !this.Validation[toneType];
      this.InsertTextToPrompt(this.Validation[toneType], toneMap[toneType]);
    },
    validate() {
      this.$refs.form.validate();
    },
    Get(id) {
      let self = this;
      self.dialog = true;
      self.loading = true;
      self.$call.GetValidationGenerateDetail(
        id,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.Edit(dataResponse.data);
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDDVectorName() {
      let self = this;
      self.dialog = true;
      self.$call.GetDDVectorDBName(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDVector = dataResponse.data;
          } else {
            self.DDVector = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    Save() {
      let self = this;
      if (self.$route.query.id) {
        self.SaveEdit();
      } else {
        self.SaveAdd();
      }
    },

    SaveAdd() {
    let self = this;
    setTimeout(() => {
      self.validate();
    }, 100);
    if (
      self.Validation.validationName == null ||
      self.Validation.validationName == '' ||
      self.Validation.amountQuestions == null ||
      self.Validation.amountQuestions <= 0 ||
      self.Validation.promptTemplate == null ||
      self.Validation.promptTemplate === '' || 
      self.Validation.vectordbName === null ||
      self.Validation.vectordbName.length === 0 
    ) {
      // Show custom warning dialog instead of swal
      self.dialog_warning = true;
      return;
    }
    self.dialog = true;
    let request = {
      name: self.Validation.validationName,
      NumberQuestions: self.Validation.amountQuestions,
      NumberQuestionsWithTone: self.Validation.amountQuestionsWithTone,
      Prompt: self.Validation.promptTemplate,
      ValidationName: self.Validation.validationName,
      VectordbName: self.Validation.vectordbName,
      Tone: self.Validation.tone,
      Temperature: self.Validation.temperature,
      TopP: self.Validation.topP,
      FrequencyPenalty: self.Validation.frequencyPenalty,
      PresencePenalty: self.Validation.presencePenalty,
      Stop: self.Validation.stop,
      MaxTokens: self.Validation.maxTokens,
      PromptMore: self.Validation.promptMore,
    };
    try {
      self.$call.CreateValidationGenerate(
        request,
        (dataResponse) => {
          if (dataResponse.status == 0) {
              self.$swal.fire({
                title: "✔ Question Set Created Successfully  !",
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                },
              });
            this.$router.push('/ValidationGenerate');
            // self.Processing(dataResponse.data);
          }else {
            self.$swal.fire({
              icon: 'warning',
              title: 'Warning',
              text: dataResponse.message,
              showConfirmButton: true,
            });
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.Adddialog = false;
          console.error(errorResource);
        }
      );
    } catch (error) {
      this.LogTrace(error, 'DeleteGroup');
    }
  },
    SaveEdit() {
      let self = this;
      setTimeout(() => {
        self.validate();
      }, 100);
      if (
        self.Validation.validationName == null ||
        self.Validation.validationName == '' ||
        self.Validation.amountQuestions == null ||
        self.Validation.amountQuestions <= 0 ||
        self.Validation.promptTemplate == null ||
        self.Validation.promptTemplate === ''
      ) {
        self.dialog_warning = true;
        return;
      }
      self.dialog = true;
      let request = {
        GenerateID: self.$route.query.id,
        name: self.Validation.validationName,
        NumberQuestions: self.Validation.amountQuestions,
        NumberQuestionsWithTone: self.Validation.amountQuestionsWithTone,
        Prompt: self.Validation.promptTemplate,
        ValidationName: self.Validation.validationName,
        VectordbName: self.Validation.vectordbName,
        Tone: self.Validation.tone,
        Temperature: self.Validation.temperature == '' ? null : self.Validation.temperature,
        TopP: self.Validation.topP == '' ? null : self.Validation.topP,
        FrequencyPenalty: self.Validation.frequencyPenalty == '' ? null : self.Validation.frequencyPenalty,
        PresencePenalty: self.Validation.presencePenalty == '' ? null : self.Validation.presencePenalty,
        Stop: self.Validation.stop,
        MaxTokens: self.Validation.maxTokens,
        PromptMore: self.Validation.promptMore,
      };
      try {
        self.$call.EditValidationGenerate(
          request,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                title: "✔ Text Successfully Updated !",
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                },
              });
              this.$router.push('/ValidationGenerate');
              // self.Processing(dataResponse.data);
            }else if (dataResponse.status == 3) {
              self.$swal.fire({
                icon: 'warning',
                title: 'Warning',
                text: dataResponse.message,
                showConfirmButton: true,
              });
              
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.Adddialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    Processing(id) {
      let self = this;
      self.dialog = true;

      let request = {
        id: id,
        entity: self.Validation.entity,
      };
      try {
        self.$call.UploadValidationGenerate(
          request,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: 'success',
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              this.$router.push('/ValidationGenerate');
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.Adddialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    Add() {
      let self = this;
      self.Clear();
      self.Adddialog = true;
      self.DDModelShow = self.DDModel;
    },
    Edit(item) {
      let self = this;
      self.Validation.validationName = item.name;
      // self.Validation.promptMore = item.prompt
      self.Validation.vectordbName = item.vectorName
      self.Validation.amountQuestions = item.numberQuestions

      self.Validation.temperature = item.temperature;
      self.Validation.topP = item.topP;
      self.Validation.frequencyPenalty = item.frequencyPenalty;
      self.Validation.presencePenalty = item.presencePenalty;
      self.Validation.stop = item.stop;
      self.Validation.maxTokens = item.maxTokens;
      self.Validation.promptMore = item.promptMore;

      self.Validation.amountQuestionsWithTone = item.numberQuestionsWithTone;
      self.Validation.tone = item.tone == null ? [] : item.tone;
      self.setToneAll(item.tone);

    },
    setToneAll(tone) {
      let self = this;
      if (tone != null) {
        self.Validation.firm = tone.includes('Firm');
        self.Validation.confident = tone.includes('Confident');
        self.Validation.poetic = tone.includes('Poetic');
        self.Validation.narrative = tone.includes('Narrative');
        self.Validation.professional = tone.includes('Professional');
        self.Validation.descriptive = tone.includes('Descriptive');
        self.Validation.humorous = tone.includes('Humorous');
        self.Validation.academic = tone.includes('Academic');
        self.Validation.persausive = tone.includes('Persausive');
        self.Validation.format = tone.includes('Format');
        self.Validation.informal = tone.includes('Informal');
        self.Validation.friendly = tone.includes('Friendly');
      }

    },

    Clear() {
      let self = this;
      self.Validation.firm = false;
      self.Validation.confident = false;
      self.Validation.poetic = false;
      self.Validation.narrative = false;
      self.Validation.professional = false;
      self.Validation.descriptive = false;
      self.Validation.humorous = false;
      self.Validation.academic = false;
      self.Validation.persausive = false;
      self.Validation.format = false;
      self.Validation.informal = false;
      self.Validation.friendly = false;
    },
    chkTone() {
      let self = this;
      return !(
        self.Validation.firm ||
        self.Validation.confident ||
        self.Validation.poetic ||
        self.Validation.narrative ||
        self.Validation.professional ||
        self.Validation.descriptive ||
        self.Validation.humorous ||
        self.Validation.academic ||
        self.Validation.persausive ||
        self.Validation.format ||
        self.Validation.informal ||
        self.Validation.friendly
      );
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumberInt: function (evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validateInput0_1(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำแหน่ง
      const value = parseFloat(inputValue);
      if (isNaN(value)) return 'Required.';
      return (value >= 0 && value <= 1 && this.isTwoDecimalPlaces(value)) || 'กรุณาป้อนตัวเลขระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำแหน่ง';
    },
    validateInput0_2(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำแหน่ง
      const value = parseFloat(inputValue);
      if (isNaN(value)) return true;
      return (value >= 0 && value <= 2 && this.isTwoDecimalPlaces(value)) || 'กรุณาป้อนตัวเลขระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำแหน่ง';
    },
    isTwoDecimalPlaces(number) {
      const regex = /^\d+(\.\d{1,2})?$/;
      return regex.test(number.toString());
    },
    isIntPlaces(number) {
      const regex = /^\d+(\d{1,2})?$/;
      return regex.test(number.toString());
    },
    InsertTextToPrompt(flag, text) {
      let self = this;
      if (flag) {
        self.Validation.tone.push(text);
      } else {
        const index = self.Validation.tone.indexOf(text);
        if (index !== -1) {
          self.Validation.tone.splice(index, 1);
        }
      }
    },
    InsertNumberQuestionToPrompt(number) {
      let self = this;
      let template = 'You will need to generate ';
      self.tempAmountQuestions = self.Validation.amountQuestions;
      if (self.Validation.amountQuestions && number) {
        self.tempAmountQuestions = self.Validation.amountQuestions;
        self.Validation.promptTemplate = self.Validation.promptTemplate.replace(template + number, template + self.Validation.amountQuestions);
      } else if (number) {
        self.Validation.promptTemplate = self.Validation.promptTemplate.replace(
          `\n- ${template}${number} questions with meaningful and relevant questions with original question from users only.`,
          ''
        );
      } else {
        self.Validation.promptTemplate += `\n- You will need to generate ${self.Validation.amountQuestions} questions with meaningful and relevant questions with original question from users only.`;
      }
    },
    processUpload(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.Validation.entity = null;
        this.uploadedFiles = [];
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.files[0]);
      reader.onload = () => {
        let text = reader.result;
        this.ValidateCSVVector(text, this.files);
      };
    },
    ValidateCSVVector(csv, files) {
      let temp = csv.replaceAll('\r', '');
      let lines = temp.split('\n');
      if (lines[0] != 'Questions') {
        this.Validation.entity = null;
        this.uploadedFiles = [];
        alert('Please Enter Correct Format!');
      } else {
        const formDataDoc = new FormData();
        formDataDoc.append('entity', files[0]);
        this.uploadedFiles = files;
        this.Validation.entity = formDataDoc;
      }
    },
    removeFile(fileName) {
      // Find the index of the
      const index = this.uploadedFiles.findIndex((file) => file.name === fileName);
      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1);
      this.$emit('filesUploaded', this.uploadedFiles);
    },
    download() {
      const data = [];
      data.push('\ufeffQuestions\n');
      data.push('จังหวัดที่อยู่เหนือสุดของประเทศไทย\n');
      data.push('จังหวัดที่อยู่ใต้สุดของประเทศไทย\n');
      data.push('จังหวัดที่มีพื้นที่มากที่สุดของประเทศไทย');

      const a = document.createElement('a');
      let blob = new Blob(data, { type: 'data:text/csv;charset=UTF-8' });
      const url = window.URL.createObjectURL(blob);

      a.href = url;
      a.download = 'upload_questions.csv';
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    },
  },
  mounted() {
    let self = this;
    self.GetDate();
    self.GetDDVectorName();
    if (self.$route.query.id) {
      self.Get(self.$route.query.id);
    }
    // self.Validation.promptTemplate =
    //   "You're assistant for generate questions from original question of users.\n#Condition\n- Your main task is to generate questions from original question of users.\n- You must know that the original question from user is not a question, you don't have to answer those questions. Your duty is to generate questions from original question of users only.\n###NUNBEROFQUESTIONS###\n###TONE###\n#Context";
    // self.Validation.promptTemplate =  "You're assistant for generate questions from original question of users.\n#Condition\n- Your main task is to generate questions from original question of users.\n- You must know that the original question from user is not a question, you don't have to answer those questions. Your duty is to generate questions from original question of users only.\n- If in the #Context consist of many topics. such as,\n1. Topic1, 2. Topic2, 3. Topic3. You will must summarize all topics into just one topic only.\n###NUNBEROFQUESTIONS###\n- You don't need to show the summary.\n###TONE###\n#Context";

    self.Validation.promptTemplate =
      "You're assistant for generate questions from original question of users.\n#Condition\n- Your main task is to generate questions from original context of users.\n- Your duty is to generate questions from original question of users only.\n- The question that you generate need to response same as context language.\n- If in the #Context consist of sub-topics you need to summarize all context first before doing generate question.\n###NUNBEROFQUESTIONS###\n- You don't need to show the summary.\n###TONE###\n###PromptMore###\n#Context";
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.icon {
  order: 0;
}

.header {
  order: 1;
  font-weight: 700;
}

.v-text-field ::v-deep label {
  font-size: 0.9375rem;
}

.v-expansion-panel-header {
  padding: 0;
}


.main-form-card {
  border-radius: 16px !important;
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08) !important;
  background: linear-gradient(135deg, #ffffff 0%, #fafbff 100%) !important;
}

.page-title {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
  line-height: 1.2;
}

.page-subtitle {
  font-size: 1rem;
  color: #64748b;
  margin: 0;
  font-weight: 400;
}

.form-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  margin-top: 2rem;
}

.form-left-panel {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-right-panel {
  display: flex;
  flex-direction: column;
}

.form-section {
  margin-bottom: 1rem;
}

.prompt-section {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.section-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #171717;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
}

.modern-expansion-panels {
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04) !important;
}

.expansion-panel-modern {
  background: white !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;
}

.expansion-panel-modern:last-child {
  border-bottom: none !important;
}

.panel-header {
  padding: 1.25rem 1.5rem !important;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%) !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.panel-title {
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
}

.panel-content {
  padding: 1.5rem !important;
  background: white !important;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}

.form-grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.tone-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.75rem;
}

.tone-checkbox {
  background: rgba(59, 130, 246, 0.05) !important;
  border: 1px solid rgba(59, 130, 246, 0.1) !important;
  border-radius: 8px !important;
  padding: 0.75rem !important;
  transition: all 0.2s ease !important;
}

.tone-checkbox:hover {
  background: rgba(59, 130, 246, 0.08) !important;
  border-color: rgba(59, 130, 246, 0.2) !important;
}

.checkbox-label {
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
}

.modern-input :deep(.v-field) {
  border-radius: 10px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
}

.modern-input :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.modern-autocomplete :deep(.v-field) {
  border-radius: 10px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
}

.modern-autocomplete :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.modern-textarea :deep(.v-field) {
  border-radius: 10px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
}

.modern-textarea :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 2rem;
  margin-top: 2rem;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  gap: 2rem;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .form-layout {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .form-grid-2 {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .tone-grid {
    grid-template-columns: 1fr;
  }
  
  .form-actions {
    flex-direction: column;
    gap: 1rem;
  }
  
  .form-actions .v-btn {
    width: 100%;
    margin: 0 !important;
  }
}

/* Animation Enhancements */
.expansion-panel-modern {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.tone-checkbox {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.modern-input, .modern-autocomplete, .modern-textarea {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.tone-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.tone-option-card {
  border: 2px solid #FFDED8 !important;
  border-radius: 12px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  cursor: pointer !important;
  background: white !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
}

.tone-option-card:hover {
  border-color: #FFDED8!important;
  box-shadow: 0 4px 12px #FFDED8 !important;
  transform: translateY(-2px) !important;
}

.tone-option-card.selected {
  border: 1px solid #FFDED8!important;
  background: #FFF2F2!important;
}

.tone-card-content {
  padding: 1rem !important;
}

.tone-checkbox-minimal {
  min-width: auto !important;
  margin: 0 !important;
  padding: 0 !important;
}

.tone-checkbox-minimal :deep(.v-input__control) {
  min-height: auto !important;
}

.tone-content {
  flex: 1;
  min-width: 0;
}

.tone-title {
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 0.25rem 0;
  line-height: 1.3;
}

.tone-description {
  font-size: 0.78rem;
  font-weight: 400;
  color: #0000006e;
  margin: 0;
  line-height: 1;
  word-wrap: break-word;
  
}

.tone-option-card.selected .tone-title {
  color: #171717;
}

.tone-option-card.selected .tone-description {
  color: #4b5563;
}

/* Icon และ Primary color updates */
/* .section-title .v-icon,
.panel-header .v-icon {
  color: rgb(59, 130, 246) !important;
} */

.modern-input :deep(.v-field--focused) {
  border-color: rgb(59, 130, 246) !important;
}

.modern-autocomplete :deep(.v-field--focused) {
  border-color: rgb(59, 130, 246) !important;
}

.modern-textarea :deep(.v-field--focused) {
  border-color: rgb(59, 130, 246) !important;
}

/* Checkbox color updates */
.tone-checkbox-minimal :deep(.v-selection-control__input .v-icon) {
  color: #C32E0E!important;
}

/* Tooltip และ info icon colors */
/* .modern-input :deep(.v-icon),
.modern-autocomplete :deep(.v-icon),
.modern-textarea :deep(.v-icon) {
  color: rgb(59, 130, 246) !important;
} */

/* Button สี primary */
.create-btn {
  background: linear-gradient(135deg, rgb(59, 130, 246) 0%, rgb(37, 99, 235) 100%) !important;
  color: white !important;
  border: none !important;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3) !important;
}

.create-btn:hover {
  background: linear-gradient(135deg, rgb(37, 99, 235) 0%, rgb(29, 78, 216) 100%) !important;
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.4) !important;
}

.create-btn:disabled {
  background: rgba(59, 130, 246, 0.5) !important;
  color: rgba(255, 255, 255, 0.7) !important;
  box-shadow: none !important;
}

/* Chip colors for autocomplete */
.modern-autocomplete :deep(.v-chip) {
  background: rgba(59, 130, 246, 0.1) !important;
  color: rgb(59, 130, 246) !important;
  border: 1px solid rgba(59, 130, 246, 0.2) !important;
}

.modern-autocomplete :deep(.v-chip:hover) {
  background: rgba(59, 130, 246, 0.15) !important;
}

/* Loading และ progress colors */
.loading-card .v-progress-circular {
  color: rgb(59, 130, 246) !important;
}

/* Expansion panel selected state */
.expansion-panel-modern :deep(.v-expansion-panel-title--active) {
  color: rgb(59, 130, 246) !important;
}

/* Responsive adjustments for tone cards */
@media (max-width: 768px) {
  .tone-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
  
  .tone-card-content {
    padding: 0.875rem !important;
  }
  
  .tone-title {
    font-size: 0.9375rem;
  }
  
  .tone-description {
    font-size: 0.8125rem;
  }
}

/* Animation for smooth state changes */
.tone-option-card {
  position: relative;
  overflow: hidden;
}

.tone-option-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.1), transparent);
  transition: left 0.6s ease;
}

.tone-option-card:hover::before {
  left: 100%;
}

/* Form field focus states */
.form-section :deep(.v-field--focused .v-field__outline) {
  --v-field-border-color: rgb(59, 130, 246) !important;
}

.form-section :deep(.v-label--active) {
  color: rgb(59, 130, 246) !important;
}

/* Page header icon */
.page-header .v-icon {
  color: rgb(59, 130, 246) !important;
}

/* Back button outline color */
.back-button[variant="outlined"] {
  border-color: #949AA8 !important;
  color: #949AA8 !important;
  
}

.back-button:hover {
  background: rgba(149, 154, 168, 0.1) !important;
}
.customback{
  text-transform: none !important;
  border-radius: 16px !important;
  font-size: 14px !important;
}
.readonly-textarea :deep(.v-field) {
  background-color: #f8f9fa !important;
  border-radius: 10px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
}

.readonly-textarea :deep(.v-field__input) {
  background-color: #f8f9fa !important;
  color: #495057 !important;
  cursor: default !important;
}

.readonly-textarea :deep(.v-field--focused) {
  border-color: rgba(59, 130, 246, 0.3) !important;
}

.readonly-textarea :deep(.v-field__overlay) {
  background-color: transparent !important;
}

.readonly-textarea :deep(.v-label) {
  color: #6c757d !important;
}

.readonly-textarea :deep(.v-field--focused .v-label) {
  color: rgb(59, 130, 246) !important;
}

/* Ensure text is still readable */
.readonly-textarea :deep(textarea) {
  color: #495057 !important;
  background-color: transparent !important;
  cursor: default !important;
}

.readonly-textarea :deep(textarea::selection) {
  background-color: rgba(59, 130, 246, 0.2) !important;
}

/* Icon styling for readonly */
/* .readonly-textarea :deep(.v-icon) {
  color: rgb(59, 130, 246) !important;
} */


.copy-btn {
  opacity: 0.7;
  transition: all 0.3s ease;
}

.copy-btn:hover {
  opacity: 1;
  background-color: rgba(59, 130, 246, 0.1) !important;
}

.copy-btn:disabled {
  opacity: 0.5 !important;
  pointer-events: none;
}

/* Success state for copy button */
.copy-btn.v-btn--color-success {
  background-color: rgba(34, 197, 94, 0.1) !important;
}

.copy-btn.v-btn--color-success:hover {
  background-color: rgba(34, 197, 94, 0.15) !important;
}

/* Icon animation */
.copy-btn :deep(.v-icon) {
  transition: all 0.3s ease;
}

.copy-btn.v-btn--color-success :deep(.v-icon) {
  color: rgb(34, 197, 94) !important;
  animation: checkmark-bounce 0.4s ease-in-out;
}

/* Checkmark bounce animation */
@keyframes checkmark-bounce {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Copying state */
.copy-btn:disabled :deep(.v-icon) {
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}

.readonly-textarea:hover .copy-btn {
  opacity: 0.9;
}

/* Icon container spacing */
.readonly-textarea :deep(.v-field__append-inner) {
  padding-left: 0.5rem;
}

/* Ensure proper alignment */
.d-flex.align-center.gap-1 > * {
  flex-shrink: 0;
}
/* Custom Accordion Styles */
.custom-accordion {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.accordion-item {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.accordion-item.is-open {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.accordion-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  cursor: pointer;
  background: #EFF4FF;
  transition: background-color 0.2s ease;
  user-select: none;
  border-radius: 12px;
}

.accordion-header:hover {
  background: #f9fafb;
}

.accordion-header-content {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.accordion-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  flex-shrink: 0;
}

.accordion-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  letter-spacing: -0.01em;
}

.accordion-chevron {
  color: #171717;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
}

.accordion-chevron.rotated {
  transform: rotate(180deg);
}

.accordion-content {
  border: 1px solid #C9C9C9;
  animation: slideDown 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: top;
  margin-top: 10px;
  border-radius: 12px;
}

.accordion-body {
  padding: 20px;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: scaleY(0.95);
  }
  to {
    opacity: 1;
    transform: scaleY(1);
  }
}

/* Warning Dialog Styles */
.warning-dialog-card {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
}

.warning-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-radius: 16px 16px 0 0;
  background: linear-gradient(90deg, #FFF8ED 0%, #FFF0DA 100%);
}

.warning-dialog-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #FFA726;
  flex: 1;
}

.warning-close-icon:hover {
  opacity: 1;
}

.warning-dialog-content {
  padding: 1.5rem !important;
  font-size: 1rem;
  color: #171717;
  background: white;
}

.warning-dialog-actions {
  padding: 1rem 1.5rem 1.5rem 1.5rem !important;
  background: white;
  justify-content: flex-end !important;
}

.warning-ok-btn {
  background: #FFA726 !important;
  color: white !important;
  font-weight: 600;
  padding: 0.5rem 2.5rem !important;
  border-radius: 8px !important;
  text-transform: none;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.3) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.warning-ok-btn:hover {
  background: linear-gradient(135deg, #fb8c00 0%, #ef6c00 100%) !important;
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.4) !important;
  transform: translateY(-1px);
}

.warning-ok-btn:active {
  transform: translateY(0);
}

</style>
